import styled from "styled-components";
import PlaceholderCard from '../../../../Images/card-placeholder-blue.png';

export const Wrapper = styled.div`
  display:flex;
  align-items:center;
  justify-content:center;

 .rccs__card--front{
    width: 320px !important;
    height: 200px !important;
    background-position: center;
    ${(props) => props && props.status === false ? `filter: opacity(0.5)` : null};
    background-repeat: no-repeat;
    background-size: cover;
    position: relative !important;
    border-radius: 20px !important;
    ${(props) => props.url !== '' && props.url !== PlaceholderCard ? 
      `background-image: url(data:image/png;base64,${props.url})!important;` 
        : 
      `background-image:url(${PlaceholderCard})!important;`
    }
  }
  .rccs__number{
    ${(props) => props.variant ==='digital-card' && `display: none` }
  }

  .carousel-indicators li{
    background-color: black;
    background-clip: initial;
    border-top: 0px;
    border-radius: 100px;
    width: 13px;
    height: 13px;
    border-bottom: 0px;
  }

  .carousel-container{
    background-color: #f1f1f1;
    display: flex;
    flex-wrap: nowrap;
    overflow: hidden
  }

  .carousel-item{
    height: 20rem;
    min-width: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 1s cubic-bezier(0.39, 0.575, 0.565, 1);
  }

`;

